module.exports = __webpack_public_path__ + "img/Icon-no-chat.15f3c174.svg";